/*****
 * Created with vscode
 * Name : 带搜索记录的输入搜索框
 * Date : 2020/2/28
 * Author : Bevis Shen
 * Func :
 *  placeholder: 输入的默认文字
 *  injectFocus: 是否聚焦
 *  inputColor: 输入框颜色
 *  on-search: 搜索时回调
 *  on-clear: 清空时回调
 ******/

<template>
  <div class="layout-search-input">
    <div
      class="search-cont"
      :class="[{focus: injectFocus}, inputColor]"
    >
      <div class="input-wrap">
        <input
          type="text"
          name="search"
          autocomplete="off"
          v-model="content"
          :placeholder="placeholder"
          @focus="focus"
          @input="searchByInput"
          @clear="clear"
        />
      </div>
      <img
        v-show="content.length"
        class="clear-input"
        @click.stop="clear"
        src="../../assets/images/jidayi-hospital/icon-search-close.png"
      />
    </div>
    <div class="search-cue">
      <ul v-if="!menuShow">
        <li v-for="(item,i) in searchHistory" :key="i" @click="searchByName(item)">{{item}}</li>
        <li class="clear-history" @click="clearHistory" v-show="searchHistory.length > 0">清除搜索历史</li>
        <li v-if="searchHistory.length === 0">暂无搜索历史</li>
      </ul>
      <div
        v-infinite-scroll="loadMore"
        infinite-scroll-immediate-check="false"
        infinite-scroll-disabled="loading"
        infinite-scroll-distance="10"
        v-show="menuShow"
      >
        <ul>
          <li v-for="(item,i) in result" :key="i" @click="goSearchResult(item)">{{item[resultItemName]}}</li>
          <li v-if="result.length === 0">未匹配到结果</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'

export default {
  name: 'SearchInputWithHistory',
  props: {
    placeholder: {
      type: String,
      default: '请输入搜索内容'
    },
    injectFocus: {
      type: Boolean,
      default: false
    },
    inputColor: {
      type: String,
      default: 'gray'
    },
    cookieName: {
      type: String,
      default: ''
    },
    result: {
      type: Array,
      default () {}
    },
    resultItemName: {
      type: String,
      default: 'name'
    }
  },
  data () {
    return {
      content: '',
      menuShow: true,
      searchHistory: [],
      isFocus: this.injectFocus,
      loading: false,
      isFirstLoad: true
    }
  },
  created () {
    this.initSearchHistory()
  },
  methods: {
    initSearchHistory () {
      let hstr = Cookies.get(this.cookieName)
      this.searchHistory = hstr ? JSON.parse(hstr) : []
    },
    clearHistory () {
      this.searchHistory = []
      Cookies.remove(this.cookieName)
    },
    goSearchResult (dept) {
      this.$emit('on-search-result', dept)
    },
    loadMore () {
      this.$emit('on-load-more')
    },
    clear () {
      this.content = ''
      this.search()
    },
    focus () {
      this.isFocus = true
      this.menuShow = false
    },
    search () {
      this.isFocus = false
      this.menuShow = true
      this.$emit('on-search', this.content)
    },
    searchByInput () {
      this.setCookie()
      this.search()
    },
    searchByName (item) {
      this.content = item
      this.search()
    },
    setCookie () {
      if (!this.content) {
        return false
      }

      this.searchHistory.splice(0, 0, this.content)
      if (this.searchHistory.length > 7) {
        this.searchHistory.pop()
      }

      Cookies.set(this.cookieName, JSON.stringify(this.searchHistory))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/SearchInputWithHistory.vue